/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Progress_Weeks_InvalidInputs */

const en_us2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Progress can show between ${i?.min} and ${i?.max} weeks.`)
};

const pt_br2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O progresso mostra entre ${i?.min} e ${i?.max} semanas.`)
};

const es_419_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El progreso muestra entre ${i?.min} y ${i?.max} semanas.`)
};

const pt_pt2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O progresso mostra entre ${i?.min} e ${i?.max} semanas.`)
};

const fr_fr2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La progression peut afficher entre ${i?.min} et ${i?.max} semaines.`)
};

const de_de2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Fortschritt zeigt zwischen ${i?.min} und ${i?.max} Wochen.`)
};

const it_it2_progress_weeks_invalid = /** @type {(inputs: Progress_Weeks_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I progressi possono mostrare da ${i?.min} a ${i?.max} settimane.`)
};

/**
* | output |
* | --- |
* | "Progress can show between {min} and {max} weeks." |
*
* @param {Progress_Weeks_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_weeks_invalid = /** @type {((inputs: Progress_Weeks_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Weeks_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_weeks_invalid(inputs)
	if (locale === "es-419") return es_419_progress_weeks_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_weeks_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_weeks_invalid(inputs)
	if (locale === "de-DE") return de_de2_progress_weeks_invalid(inputs)
	if (locale === "it-IT") return it_it2_progress_weeks_invalid(inputs)
	return en_us2_progress_weeks_invalid(inputs)
});
export { progress_weeks_invalid as "progress.weeks_invalid" }